import React from "react";
import { NavLink } from "react-router-dom";

const PageNotFound = () => {
  return (
      <section className="not-found">
        <div className="text-center pt-5 pb-5">
          <h1>
            <strong>404</strong>
          </h1>
          <h4 className="mb-4">Oops! Page Not Found.</h4>
          <NavLink to="/" className="btn btn-primary">
            Go To Home Page
          </NavLink>
        </div>
      </section>
  );
};

export default PageNotFound;
